module.exports = __webpack_public_path__ + "bishop_black.png?5f75efab63d8de8edb92ad656db158d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/art/bishop_black.png
// module id = 115
// module chunks = 0